module.exports = __webpack_public_path__ + "static/media/purchase_icon.93810cf0.svg";